import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_cart
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackViewCartItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackViewCartParameters
    extends TrackEventListParameters<"currency" | "value", null, TrackViewCartItem> {}

const trackViewCart = (parameters: TrackViewCartParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "view_cart", ...parameters }, options);
};

export default trackViewCart;
